import type { Configuration } from "@azure/msal-browser";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

/**
 * Create the app MSAL PCA. Optional config lets embed surfaces (copilot) pass
 * iframe-specific settings while sharing one factory.
 */
export function createMsalInstance(config: Configuration = msalConfig) {
    return new PublicClientApplication(config);
}
